export const digitsToNumber = (digits) => {
  if (!digits) return null;
  const cents = parseInt(digits, 10);
  if (!Number.isFinite(cents)) return null;
  return Number((cents / 100).toFixed(2));
};

export const numberToDigits = (num) => {
  if (num === null || num === undefined || Number.isNaN(Number(num))) return "";
  const cents = Math.round(Number(num) * 100);
  return String(Math.max(0, cents));
};

export const digitsToDisplay = (digits) => {
  const cents = parseInt(digits || "0", 10);
  const safe = Number.isFinite(cents) ? cents : 0;
  return (safe / 100).toFixed(2);
};

export const handleDigitsChange = (setter) => (e) => {
  const next = (e.target.value || "").replace(/\D/g, "");
  const clamped = next.slice(0, 9); // up to $9,999,999.99
  setter(clamped);
};
